/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespAppliedFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user">;
    readonly " $refType": "SbRespAppliedFilters_user";
};
export type SbRespAppliedFilters_user$data = SbRespAppliedFilters_user;
export type SbRespAppliedFilters_user$key = {
    readonly " $data"?: SbRespAppliedFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespAppliedFilters_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespAppliedFilters_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "measurementUnit",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'b1df331eb05f1806d7eef22f5659a81d';
export default node;
